import { useEffect, useState } from 'react';
import { IConfig, ValidFieldTypes } from '../../types';
import { ECardType, loadApplePay } from '../../utils';
import { isAppropriateBrowserForApplePay } from '../../components/Fields/ApplePay/util';
import { FieldViewProps } from '../../page/types';

type UseInitOtherFieldProps = {
  fieldType: string;
};

export const useInitOtherField = ({ fieldType }: UseInitOtherFieldProps): FieldViewProps & { isInit: boolean } => {
  const [isInit, setIsInit] = useState(false);
  const [data, setData] = useState<Partial<IConfig>>({});
  const [potentialCardType, setPotentialCardType] = useState<ECardType | null>(data?.preffiledCardType || null);

  useEffect(() => {
    if (fieldType === ValidFieldTypes.APPLE_PAY) {
      // For Apple Pay field we need to load Apple Pay JS before initialization
      if (isAppropriateBrowserForApplePay()) {
        loadApplePay().then(() => setIsInit(true));
      } else {
        console.error('Apple Pay is not supported on this browser.');
        setIsInit(true);
      }
    } else {
      setIsInit(true);
    }
  }, []);

  return { isInit, data, error: undefined, setData, potentialCardType, setPotentialCardType };
};
